{
  "errors": {
    "noActiveCompany": "Du har ikke valgt noe selskap",
    "noCompanySelected": "Du må velge et selskap først. Ta kontakt med din administrator.",
    "noResponseContent": "Revetall svarer ikke",
    "failedToGetResponse": "Revetall svarer ikke",
    "accessDenied": "Du har ikke tilgang til dette selskapet",
    "sessionExpired": "Du er blitt logget ut automatisk. Logg inn på nytt.",
    "genericError": "Oops! Noe gikk galt. Prøv igjen.",
    "noAuthToken": "Du er ikke logget inn. Logg inn på nytt.",
    "companyIdRequired": "Du må velge et selskap først",
    "authFailed": "Kunne ikke logge deg inn. Prøv igjen.",
    "noCompanyDataAccess": "Du har ikke tilgang til dataene for dette selskapet",
    "httpError": "Nettverksfeil! status: {{status}}",
    "companyIdRequiredForSecrets": "Du må velge et selskap først",
    "integrationTypeRequired": "Du må velge type integrasjon",
    "secretsArrayRequired": "Du må fylle inn nøkkelene dine",
    "noSecretsPermission": "Du har ikke tilgang til å endre integrasjoner for dette selskapet",
    "invalidRequestData": "Noe er feil med dataene du sendte inn",
    "companyIdRequiredForMetadata": "Du må velge et selskap først",
    "noSecretsViewPermission": "Du har ikke tilgang til å se integrasjoner for dette selskapet",
    "invalidDateRange": "Datoene du har valgt er ugyldige",
    "noCompanyAccess": "Du har ikke tilgang til noen selskaper. Ta kontakt med din administrator eller Revetall.",
    "failedToLoadCompanyInfo": "Kunne ikke laste inn selskapsinfo",
    "sqlProcessingError": "Beklager, Revetall kan ikke svare på det spørsmålet ennå. Hvis spørsmålet ditt besto av flere spørsmål, prøv å stille ett om gangen :) Det kan hjelpe!",
    "invalidLogin": "Fyll inn både e-post og passord",
    "unexpectedLoginError": "En uventet feil oppstod",
    "requiredField": "Employee Token (ETOKEN) er påkrevd"
  },
  "nav": {
    "askFox": "Spør Revetall",
    "settings": "Innstillinger",
    "logout": "Logg ut"
  },
  "sidebar": {
    "overview": "Oversikt",
    "askFox": "Spør Revetall",
    "dashboards": "Dashboard",
    "settings": "Innstillinger",
    "projects": "Prosjekter",
    "overviewDescription": "Oversikt over hvordan selskapet gjør det finansielt",
    "askFoxDescription": "AI-drevet økonomisk analyse",
    "dashboardsDescription": "Dine lagrede spørringer",
    "settingsDescription": "Integrasjoner og systeminnstillinger",
    "projectsDescription": "Administrer og følg prosjektene deres"
  },
  "auth": {
    "login": "Logg inn",
    "loggingIn": "Logger inn...",
    "email": "E-post",
    "password": "Passord",
    "emailPlaceholder": "Skriv inn din e-post",
    "passwordPlaceholder": "Skriv inn ditt passord",
    "tagline": "Laget for prosjektbedrifter som har mye å gjøre",
    "contactMessage": "Vil du prøve Revetall? Ta kontakt med oss på"
  },
  "chat": {
    "welcomeMessageLead": "Hei, jeg er Revetall!",
    "welcomeMessageBody": "Jeg har oversikt over prosjektene dine, de ansatte, regnskapet og mer — prøv å stille et spørsmål, så leter jeg i relevante data og svarer deg. Ser du noe som ikke stemmer, si ifra — vi jobber hele tiden med å bli bedre :)",
    "welcomeQuestionsIntro": "Her er noen spørsmål du kan prøve:",
    "exampleQuestions": {
      "1": "Hvordan går det hittil i år?",
      "2": "Hvilke prosjekter tjente vi mest på?",
      "3": "Hvem hos oss har høyest faktureringsgrad?",
      "4": "Hvor lenge varer bufferen vår dersom det blir dårligere tider?"
    },
    "thinking": "Revetall tenker...",
    "send": "Send",
    "sending": "Sender...",
    "placeholder": "Still meg et spørsmål:)",
    "followUpIntro": "Vil du se nærmere på noe av dette?",
    "customEllipsis": "Egen…",
    "submit": "Send",
    "cancel": "Avbryt",
    "you": "Du",
    "revetall": "Revetall",
    "share": "Del",
    "shareTitle": "Del samtale",
    "shareSave": "Lagre",
    "shareSaving": "Lagrer...",
    "shareCopy": "Kopier lenke",
    "shareCopied": "Kopiert",
    "shareNoUsers": "Ingen andre brukere i denne bedriften.",
    "shareLoadError": "Kunne ikke laste hvem samtalen kan deles med.",
    "shareSaveError": "Kunne ikke oppdatere deling.",
    "shareCopyError": "Kunne ikke kopiere lenken.",
    "shareNotFound": "Denne samtalen kan ikke deles.",
    "shareOptionLink": "Lenke",
    "shareOptionEmail": "Epost",
    "shareModeLabel": "Delingsmåte",
    "shareEmailDefaultMessage": "Hei, jeg fant noe interessant i Revetall- ta en titt så kan vi ta en prat etterpå",
    "shareEmailSend": "Send e-post",
    "shareEmailSending": "Sender...",
    "shareEmailSent": "E-post sendt.",
    "shareEmailPartialFail": "E-post kunne ikke sendes til: {{emails}}",
    "shareEmailSendError": "Kunne ikke sende e-posten."
  },
  "sessions": {
    "newConversation": "Ny samtale",
    "deleteConversation": "Slett samtale",
    "allConversations": "Alle samtaler"
  },
  "app": {
    "loading": "Laster inn...",
    "error": "Feil",
    "updateAvailable": "En ny versjon av Revetall er tilgjengelig.",
    "refreshApp": "Oppdater"
  },
  "cashBalance": {
    "notAvailable": "Ikke tilgjengelig"
  },
  "settings": {
    "title": "Innstillinger",
    "description": "Administrer integrasjoner og systemkonfigurasjon",
    "tripletex": {
      "title": "Tripletex-integrasjon",
      "description": "Konfigurer dine Tripletex API-nøkler",
      "currentConfig": "Nåværende konfigurasjon",
      "noKeys": "Ingen Tripletex-nøkler er konfigurert ennå",
      "useForm": "Bruk skjemaet nedenfor for å sette opp integrasjonen",
      "employeeToken": "Employee Token (ETOKEN)",
      "tokenPlaceholder": "Lim inn ditt Tripletex Employee Token",
      "tokenHelp": "Ditt Tripletex Employee Token for API-tilgang",
      "updateKeys": "Oppdater nøkler",
      "saveKeys": "Lagre nøkler",
      "saving": "Lagrer...",
      "adminNotice": "Kun bedriftsadministratorer kan oppdatere integrasjonsinnstillinger",
      "createdAndUpdated": "Opprettet {{created}} nøkkel(er) og oppdatert {{updated}} nøkkel(er)",
      "keysCreated": "Opprettet {{count}} Tripletex-nøkkel(er)",
      "keysUpdated": "Oppdatert {{count}} Tripletex-nøkkel(er)",
      "keysProcessed": "Tripletex-nøkler behandlet",
      "saveError": "Kunne ikke lagre nøkler. Vennligst prøv igjen.",
      "active": "Aktiv",
      "configured": "Konfigurert:"
    }
  },
  "messages": {
    "timePeriod": "Periode:",
    "sources": "Kilder:",
    "from": "til",
    "seeVisualization": "Se visualisering"
  },
  "charts": {
    "visualizations": "Visualiseringer",
    "noDataMessage": "Her vil vi vise deg visuelt det du har spurt om i chatten",
    "period": "Periode:",
    "granularity": "Detaljeringsnivå:",
    "sources": "Kilder:",
    "to": "til",
    "chartTypes": {
      "line": "Linje",
      "bar": "Søyle",
      "pie": "Kakediagram",
      "area": "Områdediagram",
      "table": "Tabell",
      "scatter": "Punktdiagram"
    },
    "graphFallbackLabel": "Graf",
    "andMore": "& {{count}} til",
    "noData": "Ingen data tilgjengelig for diagrammet",
    "value": "Verdi",
    "dataType": "Datatype:",
    "notAvailable": "Ikke tilgjengelig",
    "chartInfo": {
      "metadata": "Metadata"
    }
  },
  "dashboards": {
    "title": "Dashboard",
    "dashboardsDescription": "Dine lagrede spørringer",
    "noDashboards": "Du har ingen dashboard ennå",
    "createFirst": "Opprett ditt første dashboard for å komme i gang",
    "emptyDashboard": "Dette dashboardet er tomt",
    "emptyMessage": "Finn frem det du vil legge i dashboardet ditt ved å bruke chat-funksjonen.",
    "dashboardFull": "Dashboardet er fullt (maks {{max}} widgets)",
    "addToDashboard": "Legg til i Dashboard",
    "widgetName": "Widget-navn",
    "widgetNamePlaceholder": "Gi widgeten et navn",
    "cancel": "Avbryt",
    "add": "Legg til",
    "addedSuccessfully": "Lagt til",
    "saving": "Lagrer...",
    "selectDashboard": "Velg Dashboard",
    "sources": "Kilder:",
    "refreshWidget": "Oppdater data",
    "refreshing": "Oppdaterer...",
    "factTable": "Fakta-tabell:",
    "dimensionalTables": "Dimensjonelle tabeller:",
    "loading": "Laster inn...",
    "error": "Feil ved lasting av dashboard",
    "widgetError": "Kunne ikke laste widget-data",
    "retry": "Prøv igjen",
    "deleteWidget": "Slett Widget",
    "deleteWidgetConfirm": "Er du sikker på at du vil slette \"{{name}}\"?",
    "deleteWidgetWarning": "Denne handlingen kan ikke angres.",
    "delete": "Slett",
    "deleting": "Sletter..."
  },
  "common": {
    "close": "Lukk",
    "cancel": "Avbryt"
  },
  "overview": {
    "title": "Estimert kontantbeholdning",
    "loading": "Laster inn kontantbeholdningsdata...",
    "error": "Kunne ikke laste inn kontantbeholdningsdata",
    "noData": "Ingen kontantbeholdningsdata tilgjengelig",
    "availableCash": "Tilgjengelig kontanter",
    "events": "Hendelser",
    "viewRange": "Vis",
    "days": "dager",
    "includeNonInvoicedWork": "Inkluder ikke fakturert timearbeid",
    "includeNonInvoicedWorkExplanation": "Legger til estimerte innbetalinger fra arbeid som ennå ikke er fakturert",
    "includeOverdueInvoices": "Inkluder utestående betalinger",
    "includeOverdueInvoicesExplanation": "Legger til beløpet kunder fortsatt skylder som er forfalt, som innbetaling i morgen",
    "guideLegend": "Stiplet linje er nåværende kontantstrøm. Fylt linje inkluderer de valgte alternativene.",
    "modeLabel": "Diagrammodus",
    "modeCashflow": "På konto",
    "modeReceivables": "Utestående",
    "modeContractBacklog": "Kontraktsreserve",
    "tooltipCashflowScope": "Fremtidig kontantstrøm",
    "tooltipBacklogScope": "Historisk kontraktsreserve",
    "remainingBacklog": "Gjenstående kontraktsreserve",
    "backlogLoading": "Laster kontraktsreserve...",
    "backlogError": "Kunne ikke laste kontraktsreserve",
    "backlogNoData": "Ingen kontraktsreservedata tilgjengelig",
    "months_3": "3 mnd",
    "months_6": "6 mnd",
    "months_12": "12 mnd",
    "receivablesAge_91": "3 mnd",
    "receivablesAge_182": "6 mnd",
    "receivablesAge_365": "1 år",
    "receivablesAge_730": "2 år",
    "receivablesLoading": "Laster utestående...",
    "receivablesError": "Kunne ikke laste utestående",
    "receivablesNoData": "Ingen utestående betalinger",
    "receivablesColumns": {
      "customer": "Kunde",
      "overdue": "Utestående beløp"
    },
    "receivablesHover": {
      "invoiceNumber": "Faktura",
      "daysOverdue": "Dager forfalt",
      "billed": "Fakturert",
      "credited": "Kreditert",
      "paid": "Betalt",
      "remaining": "Utestående"
    },
    "eventNames": {
      "delta_vat": "Mva betaling",
      "employer_contribution": "Arbeidsgiveravgift",
      "inbound_invoice": "Fakturaer til forfall",
      "outbound_invoice": "Kundefakturaer til forfall",
      "projected_outbound_invoice": "Ikke fakturert timearbeid",
      "overdue_outbound_invoice": "Utestående betalinger",
      "holiday_pay": "Feriepenger",
      "payslip": "Lønnsutbetaling"
    },
    "backlogEventNames": {
      "contract_added": "Ny kontrakt",
      "contract_adjusted": "Justert kontrakt",
      "outbound_invoice": "Fakturert prosjekt",
      "project_closed": "Avsluttet prosjekt"
    }
  },
  "kpis": {
    "costPerHour": "Kostnad per time",
    "costPerHourExplanation": "Total kostnad for en time arbeid, inkludert alle utgifter",
    "personnelCostPerHour": "Personalkostnad per time",
    "personnelCostPerHourExplanation": "Personalkostnaden for en time arbeid, inkludert alle utgifter under personalkostnader",
    "breakEvenHourlyRate": "Break-even timepris",
    "breakEvenHourlyRateExplanation": "Break-even timepris er den minste timeprisen dere må ta for å dekke alle kostnader, uten å tjene eller tape penger, gitt nåværende faktureringsgrad",
    "billableRate": "Faktureringsgrad",
    "billableRateExplanation": "Andelen av timene deres som er fakturert til kunder",
    "loading": "Laster inn KPIer...",
    "error": "Kunne ikke laste inn KPIer",
    "noData": "Ingen KPI-data tilgjengelig"
  },
  "projects": {
    "title": "Prosjekter",
    "active": "Aktive",
    "inactive": "Inaktive",
    "no_activity": "Ikke påbegynte",
    "closed": "Avsluttede",
    "internal": "Interne",
    "loading": "Laster inn prosjekter...",
    "error": "Kunne ikke laste inn prosjekter",
    "noProjects": "Fant ingen prosjekter",
    "backToList": "Tilbake til prosjekter",
    "saving": "Lagrer...",
    "saveError": "Kunne ikke lagre endringer",
    "columns": {
      "sourceProjectNumber": "Nr. Tripletex",
      "name": "Navn",
      "profitability": "Lønnsomhet",
      "customer": "Kunde",
      "hours": "Timer brukt",
      "hoursSpentInvoiced": "Timer fakturert",
      "rate": "Faktisk timepris",
      "totalRevenue": "Totale inntekter",
      "totalCosts": "Totale kostnader",
      "cost": "Kostnad",
      "profit": "Fortjeneste",
      "contractValue": "Kontraktverdi",
      "remainingContractValue": "Fakturareserve",
      "remainingContract": "Fakturareserve",
      "credited": "Kreditert",
      "overInvoiced": "Overfakturert",
      "billableRate": "Faktureringsgrad",
      "otherCosts": "Andre kostnader",
      "status": "Status"
    },
    "tabs": {
      "fullOverview": "Full oversikt"
    },
    "details": {
      "startDate": "Startdato",
      "endDate": "Sluttdato",
      "personnelCost": "Lønn",
      "contributionMargin": "Dekningsgrad",
      "invoicedExplanation": "Det totale beløpet dere har fakturert kunden for dette prosjektet, før mva er lagt til.",
      "costExplanation": "Alt prosjektet har kostet dere — lønn, materialer, underentreprenører og andre utgifter.",
      "profitExplanation": "Hva dere faktisk sitter igjen med etter at alle regninger er betalt. Et positivt tall betyr at prosjektet gikk i pluss.",
      "hoursExplanation": "Alle timene teamet ditt har ført på dette prosjektet — både fakturerte og ufakturerte.",
      "rateExplanation": "Hvor mye inntekt dere tjente for hver time som ble jobbet på dette prosjektet.",
      "personnelCostExplanation": "Det dere har betalt i personalkostnader til folk som jobbet på dette prosjektet.",
      "contributionMarginExplanation": "For hver 100 kr dere fakturerer, viser dette hvor mange kr som er igjen etter at lønn er betalt. For eksempel betyr 40 % at 40 kr gjenstår av hver 100 kr fakturert.",
      "remainingContractValueExplanation": "Hvor mye av den avtalte kontraktsummen som gjenstår å fakturere. Aldri under null — beløp fakturert over kontrakten vises under Overfakturert.",
      "creditedExplanation": "Totalt beløp kreditert på dette prosjektet gjennom kreditnotaer, før mva. Vises som et positivt beløp.",
      "overInvoicedExplanation": "Hvor mye netto fakturert inntekt overstiger kontraktverdien. Tomt når prosjektet ikke er overfakturert.",
      "remainingContractPercentageExplanation": "Hvor stor prosentandel av kontrakten som gjenstår å fakturere. 50 % betyr at dere har fakturert halvparten av kontrakten så langt.",
      "contractValueSpentPercentageExplanation": "Hvor stor prosentandel av total kontraktsverdi som er fakturert så langt. 50 % betyr at dere har fakturert halvparten av kontrakten.",
      "billableRateExplanation": "Hvor stor andel av teamets timer som er fakturert til kunden. 80 % betyr at 8 av 10 arbeidede timer faktureres.",
      "materialCosts": "Materialer",
      "materialCostsExplanation": "Hva dere brukte på materialer for dette prosjektet — råvarer og varer brukt i arbeidet.",
      "subcontractorCosts": "Underleverandører",
      "subcontractorCostsExplanation": "Hva dere betalte til underentreprenører eller innleid personell som jobbet på prosjektet.",
      "logisticsCosts": "Logistikk",
      "logisticsCostsExplanation": "Transport- og fraktkostnader knyttet til dette prosjektet.",
      "otherCostsExplanation": "Eventuelle gjenværende kostnader som ikke faller inn under lønn, materialer, underentreprenører eller logistikk.",
      "hoursSpentInvoicedExplanation": "Hvor mange av de totale timene som er fakturert til kunden. Sammenlign med totale timer for å avdekke ufakturert arbeid.",
      "warningTitle": {
        "overdue": "Forfalte fakturaer",
        "profitability": "Varsel om lønnsomhet",
        "uninvoiced": "Varsel om påløpt arbeid"
      },
      "overdueInvoiceWarning": "Faktura med nummer {{invoiceNumber}} har forfalt med {{daysOverdue}} dager, utestående beløp er {{amount}} kr.",
      "overdueInvoicesSummary": "{{count}} fakturaer har forfalt for dette prosjektet, den eldste fakturaen har forfalt med {{daysOverdue}} dager, det totale utestående beløpet er {{amount}} kr.",
      "performanceOnTrack": "Prosjektet er i rute",
      "performanceFollowUp": "Du bør følge opp dette prosjektet",
      "performanceActionRequired": "Dette prosjektet krever handling nå",
      "profitabilityBelowBudget": "Dekningsgraden er {{margin}}, som er under budsjettet på {{benchmark}}.",
      "profitabilityBelowCompanyAverage": "Dekningsgraden er {{margin}}, som er under selskapsgjennomsnittet på {{benchmark}}.",
      "profitabilityAtOrBelowZero": "Dekningsgraden er {{margin}}, hvis dette fortsetter vil dere tape penger på dette prosjektet.",
      "uninvoicedWorkWarning": "Det har gått {{days}} dager siden vi forventet at dere skulle sende en faktura for dette prosjektet. Siste faktura ble sendt {{lastInvoiceDate}}, og vi har antatt at dere ville sende neste faktura rundt {{expectedDate}}.",
      "uninvoicedWorkHoursAndCosts": "Dere har ikke fakturert dette prosjektet på {{days}} dager, og det har påløpt {{hours}} timer arbeid og {{amount}} kr i kostnader etter siste faktura.",
      "uninvoicedWorkHours": "Dere har ikke fakturert dette prosjektet på {{days}} dager, og det har påløpt {{hours}} timer arbeid etter siste faktura.",
      "uninvoicedWorkCosts": "Dere har ikke fakturert dette prosjektet på {{days}} dager, og det har påløpt {{amount}} kr i kostnader etter siste faktura.",
      "uninvoicedWorkDays": "Dere har ikke fakturert dette prosjektet på {{days}} dager.",
 
 
      "sectionHours": "Timer",
      "sectionHoursDistribution": "Timefordeling",
      "sectionHoursEfficiency": "Timeeffektivitet",
      "sectionContract": "Kontrakt",
      "sectionRevenue": "Inntekter",
      "sectionCosts": "Kostnader",
      "sectionResult": "Resultat",
      "sectionEfficiency": "Effektivitet",
      "sectionProfitability": "Lønnsomhet",
      "sectionKeySummary": "Nøkkelsammendrag",
      "sectionProjectStructure": "Prosjektstruktur",
      "familyAll": "Alt",
      "margin": "Margin",
      "contractReservePercentage": "Kontraktreserve i %",
      "contractValueSpentPercentage": "Kontrakt brukt i %",
      "totalRevenueExVat": "Totale inntekter (eks. mva)",
      "revenueHours": "Timer",
      "revenueHoursExplanation": "Inntekter fra arbeid ført per time på dette prosjektet, før mva.",
      "revenueFixedPrice": "Fastpris",
      "revenueFixedPriceExplanation": "Inntekter fra fastprisleveranser på dette prosjektet, før mva.",
      "revenueMaterial": "Materialer",
      "revenueMaterialExplanation": "Inntekter fra materialer eller produktsalg på dette prosjektet, før mva.",
      "revenueOther": "Annet",
      "revenueOtherExplanation": "Andre fakturerte inntekter som ikke faller inn under timer, fastpris eller materialer, før mva.",
      "costPerHour": "Kostnad per time",
      "costPerHourExplanation": "Hva dette prosjektet koster dere per arbeidet time. Hvis dette er høyere enn timeprisen dere tar, taper dere penger på hver time.",
      "personnelCostPerHour": "Lønnskostnad per time",
      "personnelCostPerHourExplanation": "Personalkostnaden per time på dette prosjektet. Nyttig for å sjekke om folkene som jobber på prosjektet er riktig priset.",
      "contributionPerHour": "Fortjeneste per time",
      "contributionPerHourExplanation": "Hvor mye fortjeneste hver arbeidet time genererer. Et høyere tall betyr at hver time er mer verdifull for bedriften.",
      "contributionPerCost": "Avkastning på kostnader",
      "contributionPerCostExplanation": "For hver 1 kr dere bruker på dette prosjektet, hvor mye tjener dere. Over 0 betyr at dere tjener inn kostnadene og litt til.",
      "nonInvoicedWork": "Ikke fakturert timearbeid",
      "nonInvoicedWorkExplanation": "Estimert verdi av fakturerbart arbeid som ennå ikke er fakturert. Inkluderer arbeid uten faktura og arbeid knyttet til en faktura som ennå ikke er utstedt.",
      "nonInvoicedBillableHours": "Ikke fakturerte fakturerbare timer",
      "nonInvoicedBillableHoursExplanation": "Fakturerbare timer som ennå ikke er fakturert. Inkluderer timer uten faktura og timer knyttet til en faktura som ennå ikke er utstedt.",
      "hoursUnknownActivity": "Ukjent aktivitet",
      "contractBarSpent": "Fakturert",
      "includeNonInvoicedWorkExplanation": "Inkluderer timearbeid som ennå ikke er fakturert i inntekter, fortjeneste, margin og timepris.",
      "includeNonInvoicedWorkHint": "Tar med timearbeid som er utført, men enda ikke fakturert.",
      "contractBarRemaining": "Gjenstår",
      "sectionPlannedVsActual": "Planlagt vs Faktisk",
      "plannedBudgetPrompt": "Vil du se prosjektet mot planen? Send excelark, tilbudsbrev eller liknende til",
      "planned": "Planlagt",
      "actual": "Faktisk",
      "percentUsed": "% Brukt",
      "hourRate": "Timepris"
    }
  }
}

